.panel {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-3);
  padding: var(--tuna-spacing-3);
  border: 1px solid var(--tuna-border-default);
  border-radius: var(--tuna-shape-borderRadius);
}

.heading {
  margin: 0;
  font-size: var(--tuna-typography-h3-fontSize);
}

.signature {
  margin: 0;
  color: var(--tuna-content-secondary);
}

.playBtn {
  align-self: flex-start;
}

.row,
.cluster {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-1);
}

.rowLabel {
  font-weight: 600;
  color: var(--tuna-content-secondary);
}

.clusterRow {
  display: flex;
  flex-wrap: wrap;
  gap: var(--tuna-spacing-1);
}

.linkBtn {
  text-transform: none;
}
